import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isValidValue } from "utils/Utils";
import AppOutlineButton from "components/ui/AppOutlineButton";

const CancelOrder = ({ cancelsliderOrder, cancelOrder }) => {
  const { t } = useTranslation();
  const { orderInfo } = useSelector((state) => state?.LogisticReducer);

  const nonCancelableStatuses = [
    "PICKED_UP",
    "DELIVERED",
    "REACHED_CUSTOMER_LOCATION",
    "CANCELED",
  ];
  const currentStatus = orderInfo?.logisticPartnerMetadata?.SLIDER?.deliveryStatus;

  if (
    isValidValue(
      orderInfo?.logisticPartnerMetadata?.SLIDER?.createDeliveryResponse?.order_number
    )
  ) {
    if (nonCancelableStatuses.includes(currentStatus)) {
      return (
        <div className="flex justify-center p-4">
          <div className="text-red-600 font-semibold">
            {t("Order cannot be cancelled at this stage.")}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="flex justify-center p-4">
            <AppOutlineButton variant="secondary" size="lg" onClick={cancelsliderOrder}>
              {t("Cancel order with Slider")}
            </AppOutlineButton>
          </div>
        </div>
      );
    }
  } else if (cancelOrder?.status === "CANCELLED") {
    return (
      <div className="flex justify-center p-4">
        <div>{t("Order Has been Cancelled Already")}</div>
      </div>
    );
  }

  return (
    <div className="flex justify-center p-4">
      <div>
        {t(
          "You haven’t sent your order to Slider delivery yet, you can send it by clicking SEND ORDER tab"
        )}
      </div>
    </div>
  );
};

export default CancelOrder;
